import React from 'react';
import classes from './Button.module.css';

const Button = ({ title, onClick, className, children, disabled }) => {
  return (
    <>
      <button
        onClick={onClick}
        className={classes['app-button'] + ` ${className}`}
        disabled={disabled}
      >
        {title}
        {children}
      </button>
    </>
  );
};

export default Button;
